import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { NewCampaignDialog } from "./NewCampaignDialog";
import MarketingMessages from "./MarketingMessages";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";
import { useNavigate } from "react-router-dom";
import SearchBarWithButton from "../BroadcastFBManage/DMComponents/SearchBarWithButton";
import CampaignsList from "../BroadcastFBManage/DMComponents/CampaignsList";

interface Campaign {
  messageCampaignId: any;
  messageCampaignName: string;
  lifetimeBudget: number;
  campaignStatus: boolean;
}

const CampaignsDashboard: React.FC = () => {
  const history = useNavigate();

  const { sideBar } = useProductsContext();
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [routeToMM, setRouteToMM] = useState(false);
  const [routeToCampaigns, setRouteToCampaigns] = useState(true);
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [editCampaign, setEditCampaign] = useState<any>(null);

  const filteredCampaigns = campaigns.filter((campaign) =>
    campaign.messageCampaignName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const {
    facebook: { pageId },
  } = JSON.parse(localStorage.getItem("fbbPageDetail") || "{}");

  const { adAccountId, adAccountName, adAccountCurrency } = JSON.parse(
    localStorage.getItem("fbbAdAccountDetail") || "{}"
  );

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = () => {
    if (pageId) {
      let pageDataReq = `pageId=${pageId}&adAccountId=${adAccountId}`;
      try {
        NetworkManager.sendJsonRequest(
          "broadcastMessageTemplates/getMessageCampaigns",
          "",
          pageDataReq,
          "GET",
          true,
          onSuccessCall,
          onErrorCall
        );
      } catch (error) {}
    }
  };

  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "BM0000") {
        const campaignsList = respData.messageCampaignDetails;
        setCampaigns(campaignsList);
      } else if (respData.statusCode !== "BM0000") {
        ToastManager.showToast("No message campaigns are available.", "Error");
      }
    }
  };

  const onErrorCall = (err: any) => {};

  const handleOpenCreate = () => {
    setOpenDialog(true);
    setEditCampaign(null);
  };

  const handleRouteToMM = (campaign: any) => {
    localStorage.setItem("selectedCampaign", JSON.stringify(campaign));
    setRouteToCampaigns(false);
    setRouteToMM(true);
  };
  const handleBackToCampaigns = () => {
    setRouteToMM(false);
    setRouteToCampaigns(true);
  };
  const handleBackToPages = () => {
    history("/existingbroadcastpages");
  };

  const handleSaveCampaign = (newCampaign: Campaign) => {
    setCampaigns((prev) => {
      const existsCampaign = prev.some(
        (campaign) =>
          campaign.messageCampaignId === newCampaign.messageCampaignId
      );
      if (existsCampaign) {
        return prev.map((campaign) =>
          campaign.messageCampaignId === newCampaign.messageCampaignId
            ? newCampaign
            : campaign
        );
      } else {
        return [...prev, newCampaign];
      }
    });
  };

  return (
    <Box
      className="content-page"
      sx={{
        ml: sideBar ? "250px" : "120px",
        backgroundColor: "#fff",
        mr: 10,
      }}>
      <Box className="content">
        {routeToCampaigns && !routeToMM && (
          <Grid container spacing={2} mt={1}>
            <Grid item xs={4} mt={2}>
              <Button
                variant="outlined"
                sx={{ textTransform: "none", ml: 16 }}
                onClick={handleBackToPages}>
                ← Back To Pages
              </Button>
            </Grid>
            <Grid item xs={8} mt={2}>
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                sx={{ textAlign: "start", ml: 10 }}>
                DM Campaigns
              </Typography>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={10} lg={8}>
                <SearchBarWithButton
                  placeholder="Search Campaign Name..."
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  onNew={handleOpenCreate}
                  newBtnLabel="+ Create Campaign"
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              className="custom-scrollbar-css"
              sx={{ height: "60vh" }}>
              <Grid item xs={12} md={10} lg={8}>
                <CampaignsList
                  campaigns={filteredCampaigns}
                  adAccountName={adAccountName}
                  adAccountCurrency={adAccountCurrency}
                  onOpenMessages={handleRouteToMM}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        <NewCampaignDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onSave={handleSaveCampaign}
          editCampaign={editCampaign}
          fetchCampaigns={fetchCampaigns}
        />
      </Box>
      {routeToMM && (
        <MarketingMessages handleBackToCampaigns={handleBackToCampaigns} />
      )}
    </Box>
  );
};
export default CampaignsDashboard;
